import Modal from 'components/Modal/Modal'
import {Formik} from 'formik'
import React, {useContext, useMemo} from 'react'
import useTranslate from 'modules/local/useTranslate'
import {NavigationContext} from 'modules/navigation/NavigationContext'
import {post_create_Api} from "../../apis";
import {Button, Segmented,} from "antd";
import MegaTextarea from "../../components/Feed/InputBoard/MegaTextarea";
import {NotificationActionTypes, successNotify} from "../AppLocals/factory/createNotification";
import {notifyOnError} from "../AppLocals/factory/createErrorEvent";
import useAsyncAction from "../../modules/asyncCache/useAsyncAction";
import {NullAsDefault} from "views/Shared";
import MentionDataContext from "../../components/Feed/MentionDataContext";
import {getId} from 'apis/model/base'
import Pure from "../../components/Pure";
import {useSelectEntities} from "../../redux/entities/useSelectEntities";
import {getType} from "../../apis/model/base";
import {LoginContext} from "../../components/LoginContext";
import {getContentSchema} from "../../apis/schema";
import {LayoutContext} from "../../components/layouts/Default/LayoutContext";
import _ from "lodash"
import {
    AnnouncementFeedCard,
    EmbedFeedCard,
    UserCheckinFeedCard,
    WoGFeedCard
} from "../../components/Feed/TimeLineFeed";
import {createValue} from "../../components/form/utils";
import LookupField from "../../components/LookupField";
import PostSettingForm from "../../components/Feed/PostForm/PostSettingForm";
import PostFormContext from "../../components/Feed/PostForm/PostFormContext";

const FeedQuoteForm = ({type, id, onCancel}) => {
    const t = useTranslate()
    const login = useContext(LoginContext)
    const {isSm} = useContext(LayoutContext)
    const item = useSelectEntities(
        id,
        getContentSchema(type)
    )
    const mentions = Array.from(item?.mentions ?? [])
    const {push = NullAsDefault, toString = NullAsDefault} = useContext(MentionDataContext)
    const {options, ...postFormContextProps} = useContext(PostFormContext)

    const {handleAsyncAction, isLoading: isSubmitting} = useAsyncAction({
        onError: notifyOnError(t),
        apiInfo: post_create_Api,
        onSuccess: () => {
            successNotify(NotificationActionTypes.CREATE)
            onCancel()
        },
    })

    const validate = (values) => {
        let errors = {}
        return errors
    }

    const defaultChannel = useMemo(() => {
        return _.first(
            (options || []).filter(
                (e) =>
                    getType(_.get(e, "data.owner")) === getType(login) &&
                    getId(_.get(e, "data.owner")) === getId(login)
            )
        );
    }, [options, login]);

    const _initialValues = useMemo(() => {
        return {
            embed_type: getType(item),
            embed_id: getId(item),
            description: "",
            privacy: 1,
            post_type: "post",
            containers: options,
            default_owner_id: login?.id,
            default_container_id: defaultChannel?.value,
        };
    }, [item, options, login, defaultChannel]);

    const renderFeedCard = useMemo(() => {
        const type = getType(item);

        switch (type) {
            case "god_word":
                return <WoGFeedCard item={item}/>
            case "user_checkin":
                return <UserCheckinFeedCard item={item}/>
            case "course_class_announcement":
            // TODO: làm cái khác gắn vào nếu khác
            case "organization_announcement":
                return <AnnouncementFeedCard item={item}/>
            case "prayer":
                return <EmbedFeedCard item={item}/>
            default:
                return (
                    <EmbedFeedCard item={item}/>
                )
        }

    }, [item])

    return (
        <NavigationContext.Consumer>
            {({handleGoBack}) => (
                <Modal
                    width={540}
                    className="custom-modal"
                    open={true}
                    title={
                        <div className="text-center text-color-000 font-bold uppercase">{t('repost')}</div>
                    }
                    footer={null}
                    onCancel={onCancel || handleGoBack}>
                    <div className="space-y-3">
                        {item && (
                            <Formik
                                validate={validate}
                                enableReinitialize={true}
                                onSubmit={(values) => {
                                    const {
                                        owner,
                                        container,
                                        containers,
                                        default_owner_id,
                                        default_container_id,
                                        isLoading,
                                        ...rest
                                    } = values ?? {}
                                    handleAsyncAction(
                                        _.omitBy(
                                            {
                                                owner_id: getId(owner?.data) ? getId(owner?.data) : getId(login),
                                                owner_type: getId(owner?.data) ? getType(owner?.data) : "user",
                                                container_id: getId(container?.data) ? getId(container?.data) : default_container_id,
                                                container_type: getId(container?.data) ? getType(container?.data) : "channel",
                                                ...rest,
                                            },
                                            _.isUndefined
                                        ),
                                        {
                                            id: getId(container?.data) ? getId(container?.data) : default_container_id,
                                            prop: getId(container?.data) ? getType(container?.data) : "channel",
                                        }
                                    )
                                    // handleAsyncAction(values, {})
                                }}
                                initialValues={_initialValues}>
                                {({values, handleSubmit, handleChange}) => (
                                    <div className="flex flex-col gap-6">
                                        <div className="flex gap-3">
                                            <div className="flex flex-col flex-1 gap-3">
                                                <PostSettingForm/>
                                                <div className="flex items-center gap-3">

                                                    <Segmented
                                                        onChange={(value) => {
                                                            handleChange(createValue('post_type', value))
                                                        }}
                                                        options={[
                                                            {
                                                                label: t('news post'),
                                                                value: 'post',
                                                            },
                                                            {
                                                                label: t('prayer intention'),
                                                                value: 'prayer',
                                                            },
                                                        ]}
                                                        className="custom-segmented-secure"
                                                    />

                                                    {values?.post_type === "prayer" && (
                                                        <LookupField
                                                            createIfNotExists={true}
                                                            defaultValue={values?.prayer_category}
                                                            apiPath={`/lookup/prayer_category/gets`}
                                                            placeholder={t('click to select')}
                                                            name="prayer_category"
                                                            renderOption={(o, i) => {
                                                                return (
                                                                    <div key={i}
                                                                         className="flex flex-col justify-center flex-1">
                                                                        <span
                                                                            className="font-semibold text-sm text-color-000 tracking-wide leading-snug">
                                                                            {o?.label}
                                                                        </span>
                                                                        {o?.description && (
                                                                            <span
                                                                                className="text-xs text-color-300 italic tracking-wider leading-snug">
                                                                                {o?.description}
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                )
                                                            }}
                                                            handleChange={(e) => {
                                                                handleChange(createValue('prayer_category', e.target.value))
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                                <MegaTextarea
                                                    rows={5}
                                                    values={{}}
                                                    name="description"
                                                    value={values?.description}
                                                    onChange={handleChange}
                                                    placeholder={t('type comment - enter new row')}
                                                    wrapperClassName="shadow-items rounded-md border border-primary-500"
                                                    mention_count={mentions.length}
                                                    fieldNames={{
                                                        embed_data: 'embed_data',
                                                        description: 'description',
                                                    }}
                                                    onMentioned={(mention) => {
                                                        push(mention)
                                                    }}
                                                    renderActions={() => null}
                                                />
                                                <Pure input={[item]}>
                                                    {renderFeedCard}
                                                </Pure>
                                            </div>
                                        </div>
                                        <div className="w-full flex items-center justify-end gap-3">
                                            <Button
                                                onClick={onCancel}
                                                className="button-rounded-lg no-border text-color-200">
                                                {t('close')}
                                            </Button>
                                            <Button
                                                onClick={handleSubmit}
                                                type="primary"
                                                className="button-rounded-lg font-medium no-border">
                                                {t('publish a post')}
                                            </Button>
                                        </div>
                                    </div>
                                )}
                            </Formik>
                        )}
                    </div>
                </Modal>
            )}
        </NavigationContext.Consumer>
    )
}
export default FeedQuoteForm
